import React from 'react';

/*
import {
  hf,
  ht,
  cr,
  a,
  f,
  ls,
  gs,
  BtnC,
  BtnTopC,
  TblC,
  TextC,
} from 'lib';
*/
import * as TextC from "./_ccbTextC";
import * as BtnC from "./_cccBtnC";
import * as BtnTopC from "./_ccmBtnTopC";
import * as TblC from "./_ccmTblC";
import * as f from "./_cmFTH"; // 廃止予定
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as ls from "./_csLcl"; // local state
import * as ht from './_ht';

import * as ica from 'src/ica';

import * as icvi19 from './icvI19___Mz';

let $_20rs = [] as ht.ls;

export const B = (pz: ht.btnTopCz) => {
  return (
    cr.c(BtnTopC.N, {
      key: -10,
      ... pz,
      cz: {
        ... pz.cz,
      }
    })
  )
};

export const L = (pz: ht.viewListCz) => {

  const _frcUdt = ls.frcUdt();

/*
  React.useEffect(() => {
    f.loadAllAsync({
      frcUdt: _frcUdt,
      bfrAsync: () => [
        icvi19.load_20rLsAsync()
        .then((_ls: ht.ls) => {
          $_20rs = _ls
        })
      ]
    });
  }, [
  ]);
*/

  React.useEffect(() => {
    f.loadAllAsync({
      frcUdt: _frcUdt,
      bfrAsync: () => [
        icvi19.load_20rLsAsync()
        .then((_ls: ht.ls) => {
          $_20rs = _ls
        })
      ]
    });
  }, [])

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.viewListAbtz[_abtType] ? ica.viewListAbtz[_abtType]() : {};

  const _hdrs = [] as ht.ls;
  const _cellCs = [
    {
      boxStlz: a('f/0.25'),
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          ... _abtz.hdrCz.textCz,
          textz: {
            pfx: 'ID',
            stlz: a(`tc/${pz.cz.ccd}7`),
          }
        })
      ]
    },
    {
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          ... _abtz.hdrCz.textCz,
          textz: {
            pfx: 'クライアント名',
            stlz: a(`tc/${pz.cz.ccd}7`),
          }
        })
      ]
    },
    {
      boxStlz: a('f/0.25'),
      oClds: [
      ]
    },
  ];
  _hdrs.push(
    {
      cellCs: _cellCs
    },
  );

  const _rows = [] as ht.ls;
//  $i17rLs.map( ( _i18rz: ht.dz ) => {
  $_20rs.map( ( _dz: ht.dz ) => {
    const _cellCs = [
      {
      boxStlz: a('f/0.25'),
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            textz: {
              pfx: _dz._icn,
            }
          })
        ]
      },
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            textz: {
              pfx: _dz._pfx,
              ptyz: a('tn/1'),

            }
          })
        ]
      },
      {
        boxStlz: a('f/0.25'),
        oClds: [
          cr.c(BtnC.N, {
            key: -10,
            ... _abtz.bdyCz.btnCz,
            boxStlz: a(`sc/${pz.cz.ccd}5`),
            lblCz: {
            },
            pslPtyz: {
              onPress: () => {
                pz.sPz.set({
                  steps: [1],
                  phs: 'dpy',
                  _20r_key: _dz._key,
                })
              }
            },
          })
        ]
      },
    ];
    _rows.push(
      {
        cellCs: _cellCs
      },
    )
  });

  return (
    cr.c(TblC.N, {
      key: -30,
      ... _abtz.tblCz,
      srlCz: {
        srlStlz: {
          otrz: a('dwx/60'),
        },
      },
      hdrCz: {
        boxStlz: a(`bc/${pz.cz.ccd}7`),
        lineCs: _hdrs,
      },
      bdyCz: {
        boxStlz: a(`bc/${pz.cz.ccd}7`),
        lineCs: _rows,
      },
    })
  );
};
